import { Component } from 'react';
import { Text, View } from 'react-native';

import { translate } from '../../../i18n';
import DeliveryAddressCard from '../../CheckoutPage/DeliveryAddressCard/DeliveryAddressCard';
import styles from './DeliverySection.style';
import ReceiptDataField from './ReceiptDataField';
import type { InvoiceDataProps } from './types';

interface Props {
  invoiceData: InvoiceDataProps;
  deliveryData: any;
}

export default class DeliverySection extends Component<Props> {
  render() {
    const { deliveryData, invoiceData } = this.props;

    return (
      <View style={[styles.billDetailSection]}>
        <View style={styles.dataField}>
          <Text style={styles.dataKeyText}>
            {translate('shipping-method-with-symbol')}
          </Text>
          <Text style={[styles.dataValueLayout, styles.dataValueText]}>
            {deliveryData.shipping_hint}
          </Text>
        </View>
        <View style={styles.addressCardField}>
          <DeliveryAddressCard
            testID="deliveryAddressCard"
            deliveryData={deliveryData}
          />
        </View>
        <ReceiptDataField invoiceData={invoiceData} />
      </View>
    );
  }
}
